import { useLocation, useParams } from 'react-router-dom'

import type { KyrgyzstanGalleryRouteState } from 'entities/kyrgyzstan/lib'
import { ImageGalleryWrapper } from 'entities/kyrgyzstan/ui/image-gallery-wrapper'

const KyrgyzstanGalleryImagePage = () => {
  const { id, imageIndex } = useParams<{ id: string; imageIndex: string }>()
  const { state } = useLocation()
  const initialIndex = Number(imageIndex) || 0

  const gallery = (state as KyrgyzstanGalleryRouteState | null)?.gallery
  const data = gallery?.realtyId === id ? gallery : null

  return (
    <ImageGalleryWrapper
      images={data?.images || []}
      title={data?.title || ''}
      initialIndex={initialIndex}
      isLoading={false}
      error={null}
    />
  )
}

export default KyrgyzstanGalleryImagePage
